import type { FaireProductEntity } from "../../entity_types/product";

export const p_r4ubha28r2: FaireProductEntity = {
  token: "p_r4ubha28r2",
  type: "product",
  name: "Beauty Of Simplicity Earrings",
  brandToken: "b_eow5j1bbc8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/a6ac9d987310454beda9d7368a863a6a6dd54902ebeed0bf64c102d61ed3474e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fba6e25bcde6d41f5bb2f350fbfe7bef8a14de3de2813d042e2784f50d902703.jpeg",
    "https://cdn.faire.com/fastly/60e409946e792a6882e1e0cb6b66cf436683e0e3a6ca2618cca9338149a7af70.jpeg",
    "https://cdn.faire.com/fastly/e73b427f4fd68f7a1af1444eb82c45afc606ef877abfe991461a4dfa92a1bb32.jpeg",
    "https://cdn.faire.com/fastly/06f3cdb6e6261348bc9a5b431cbabf8d26ebe7db35d4b412fb6417b73dd586db.jpeg",
    "https://cdn.faire.com/fastly/592e31be8d86b1b86ed751ac093c6672b79a002866b37b3e1e72736444af2524.jpeg",
    "https://cdn.faire.com/fastly/691adc11bd361f2f0af11746325294675decb7f994ec36d2ccd192e8c3f66976.jpeg",
    "https://cdn.faire.com/fastly/80bd2ea076becdfb47ba1fa537773a268970143f13f2439f5d8c74216f28acdd.jpeg",
    "https://cdn.faire.com/fastly/b8dd49812b441cb0ad30349565d2364a4c013628110e1467c41f884be368ed2f.jpeg",
    "https://cdn.faire.com/fastly/f4bc3f51178f10aa8de0cd90f5a5761126dc8b45727f9c6e4df6e345c141fe24.jpeg",
    "https://cdn.faire.com/fastly/a4251b64ab42fc8289e1be856c611266d08f1e7d85feb8cb2ecf2af4d738349e.jpeg",
    "https://cdn.faire.com/fastly/14efaf29a9ee46a28d5a972dab487dcd72af4783f2ed8fb7c620e6a9eb8c431f.jpeg",
  ],
  priceDollars: 14.94,
  description:
    'Has a simple, yet stylish edge. Sleek and subtle design add a touch of charm to any outfit. With gorgeous polished finish, the earrings is sure to leave a lasting impression.\n\nDimensions: approximately 1.25" long\n\n18K Gold Plated plated Brass\n\nLead and Nickel Free',
  tags: [],
  msrpDollars: 29.87,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:23.745Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
